import React from "react";
import ReactDOM from "react-dom/client";
import SimpleAlbedo from "./components/SimpleAlbedo";
import "./styles/index.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <SimpleAlbedo />
  </React.StrictMode>
);

